const router = [
  {
    path: '/projectFile',
    name: 'projectFileList',
    meta: { title: '项目资料汇编' },
    component: () => import('@/views/setting/projectFile/List.vue')
  },
  {
    path: '/projectFile/Detail:projectId',
    name: 'projectFileDetail',
    meta: { title: '详情',
      activeMenu: '/projectFile'
     },
    component: () => import('@/views/setting/projectFile/Detail.vue')
  }
]

export default router
